import type { UserBalanceResponse } from '../../declarations/ah-api';
import * as types from '../actions/action-types';

export default function userBalanceReducer(
  state: UserBalanceResponse = null as any as UserBalanceResponse,
  action: any
): UserBalanceResponse {
  switch (action.type) {
    case types.LOAD_USER_BALANCE_SUCCESS:
      return {
        ...state,
        ...(action.userBalance as UserBalanceResponse),
      };

    default:
      return state;
  }
}
